var cov_p96fimrz6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/hoc/delay.tsx",
      hash = "68a5aa8e4af8a803881ae9f615ae0ad89a5ba9be",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/hoc/delay.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 82,
          column: 52
        }
      },
      "1": {
        start: {
          line: 18,
          column: 8
        },
        end: {
          line: 18,
          column: 20
        }
      },
      "2": {
        start: {
          line: 20,
          column: 8
        },
        end: {
          line: 22,
          column: 9
        }
      },
      "3": {
        start: {
          line: 24,
          column: 8
        },
        end: {
          line: 24,
          column: 56
        }
      },
      "4": {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 54
        }
      },
      "5": {
        start: {
          line: 26,
          column: 8
        },
        end: {
          line: 26,
          column: 56
        }
      },
      "6": {
        start: {
          line: 30,
          column: 8
        },
        end: {
          line: 30,
          column: 54
        }
      },
      "7": {
        start: {
          line: 30,
          column: 31
        },
        end: {
          line: 30,
          column: 54
        }
      },
      "8": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 31
        }
      },
      "9": {
        start: {
          line: 35,
          column: 26
        },
        end: {
          line: 35,
          column: 36
        }
      },
      "10": {
        start: {
          line: 36,
          column: 8
        },
        end: {
          line: 36,
          column: 45
        }
      },
      "11": {
        start: {
          line: 36,
          column: 33
        },
        end: {
          line: 36,
          column: 45
        }
      },
      "12": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 59
        }
      },
      "13": {
        start: {
          line: 37,
          column: 40
        },
        end: {
          line: 37,
          column: 59
        }
      },
      "14": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 27
        }
      },
      "15": {
        start: {
          line: 42,
          column: 22
        },
        end: {
          line: 42,
          column: 37
        }
      },
      "16": {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 46,
          column: 9
        }
      },
      "17": {
        start: {
          line: 44,
          column: 10
        },
        end: {
          line: 44,
          column: 45
        }
      },
      "18": {
        start: {
          line: 45,
          column: 10
        },
        end: {
          line: 45,
          column: 16
        }
      },
      "19": {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 32
        }
      },
      "20": {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 32
        }
      },
      "21": {
        start: {
          line: 51,
          column: 8
        },
        end: {
          line: 51,
          column: 26
        }
      },
      "22": {
        start: {
          line: 52,
          column: 8
        },
        end: {
          line: 52,
          column: 60
        }
      },
      "23": {
        start: {
          line: 52,
          column: 30
        },
        end: {
          line: 52,
          column: 60
        }
      },
      "24": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 56,
          column: 17
        }
      },
      "25": {
        start: {
          line: 54,
          column: 10
        },
        end: {
          line: 54,
          column: 35
        }
      },
      "26": {
        start: {
          line: 55,
          column: 10
        },
        end: {
          line: 55,
          column: 45
        }
      },
      "27": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 60
        }
      },
      "28": {
        start: {
          line: 60,
          column: 30
        },
        end: {
          line: 60,
          column: 60
        }
      },
      "29": {
        start: {
          line: 64,
          column: 8
        },
        end: {
          line: 64,
          column: 27
        }
      },
      "30": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 32
        }
      },
      "31": {
        start: {
          line: 66,
          column: 8
        },
        end: {
          line: 66,
          column: 43
        }
      },
      "32": {
        start: {
          line: 67,
          column: 8
        },
        end: {
          line: 67,
          column: 33
        }
      },
      "33": {
        start: {
          line: 71,
          column: 46
        },
        end: {
          line: 71,
          column: 56
        }
      },
      "34": {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 80,
          column: 9
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 11,
            column: 3
          },
          end: {
            line: 11,
            column: 4
          }
        },
        loc: {
          start: {
            line: 12,
            column: 4
          },
          end: {
            line: 82,
            column: 52
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 17,
            column: 6
          },
          end: {
            line: 17,
            column: 7
          }
        },
        loc: {
          start: {
            line: 17,
            column: 37
          },
          end: {
            line: 27,
            column: 7
          }
        },
        line: 17
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 29,
            column: 6
          },
          end: {
            line: 29,
            column: 7
          }
        },
        loc: {
          start: {
            line: 29,
            column: 17
          },
          end: {
            line: 32,
            column: 7
          }
        },
        line: 29
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        },
        loc: {
          start: {
            line: 34,
            column: 17
          },
          end: {
            line: 39,
            column: 7
          }
        },
        line: 34
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 6
          },
          end: {
            line: 41,
            column: 7
          }
        },
        loc: {
          start: {
            line: 41,
            column: 55
          },
          end: {
            line: 57,
            column: 7
          }
        },
        line: 41
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 53,
            column: 38
          },
          end: {
            line: 53,
            column: 39
          }
        },
        loc: {
          start: {
            line: 53,
            column: 44
          },
          end: {
            line: 56,
            column: 9
          }
        },
        line: 53
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 59,
            column: 7
          }
        },
        loc: {
          start: {
            line: 59,
            column: 21
          },
          end: {
            line: 61,
            column: 7
          }
        },
        line: 59
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 63,
            column: 6
          },
          end: {
            line: 63,
            column: 7
          }
        },
        loc: {
          start: {
            line: 63,
            column: 54
          },
          end: {
            line: 68,
            column: 7
          }
        },
        line: 63
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 7
          }
        },
        loc: {
          start: {
            line: 70,
            column: 15
          },
          end: {
            line: 81,
            column: 7
          }
        },
        line: 70
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 54
          }
        }, {
          start: {
            line: 30,
            column: 8
          },
          end: {
            line: 30,
            column: 54
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 45
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 45
          }
        }, {
          start: {
            line: 36,
            column: 8
          },
          end: {
            line: 36,
            column: 45
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 59
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 59
          }
        }, {
          start: {
            line: 37,
            column: 8
          },
          end: {
            line: 37,
            column: 59
          }
        }],
        line: 37
      },
      "3": {
        loc: {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 46,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 46,
            column: 9
          }
        }, {
          start: {
            line: 43,
            column: 8
          },
          end: {
            line: 46,
            column: 9
          }
        }],
        line: 43
      },
      "4": {
        loc: {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 60
          }
        }, {
          start: {
            line: 52,
            column: 8
          },
          end: {
            line: 52,
            column: 60
          }
        }],
        line: 52
      },
      "5": {
        loc: {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 60
          }
        }, {
          start: {
            line: 60,
            column: 8
          },
          end: {
            line: 60,
            column: 60
          }
        }],
        line: 60
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/hoc/delay.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import config from '../config';
import { curry } from '../utils/func';
export default curry(function (defaultDelay, Origin) {
  var _temp;

  cov_p96fimrz6.f[0]++;
  cov_p96fimrz6.s[0]++;
  return _temp =
  /*#__PURE__*/
  function (_PureComponent) {
    _inherits(_temp, _PureComponent);

    var _super = _createSuper2(_temp);

    function _temp(props) {
      var _this;

      _classCallCheck(this, _temp);

      cov_p96fimrz6.f[1]++;
      cov_p96fimrz6.s[1]++;
      _this = _super.call(this, props);
      _this.changeLocked = void 0;
      _this.changeTimer = void 0;
      cov_p96fimrz6.s[2]++;
      _this.state = {
        value: props.value
      };
      cov_p96fimrz6.s[3]++;
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
      cov_p96fimrz6.s[4]++;
      _this.forceChange = _this.forceChange.bind(_assertThisInitialized(_this));
      cov_p96fimrz6.s[5]++;
      _this.cancelChange = _this.cancelChange.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_temp, [{
      key: "getValue",
      value: function getValue() {
        cov_p96fimrz6.f[2]++;
        cov_p96fimrz6.s[6]++;

        if (this.changeLocked) {
          cov_p96fimrz6.b[0][0]++;
          cov_p96fimrz6.s[7]++;
          return this.state.value;
        } else {
          cov_p96fimrz6.b[0][1]++;
        }

        cov_p96fimrz6.s[8]++;
        return this.props.value;
      }
    }, {
      key: "getDelay",
      value: function getDelay() {
        cov_p96fimrz6.f[3]++;

        var _ref = (cov_p96fimrz6.s[9]++, this.props),
            delay = _ref.delay;

        cov_p96fimrz6.s[10]++;

        if (delay !== undefined) {
          cov_p96fimrz6.b[1][0]++;
          cov_p96fimrz6.s[11]++;
          return delay;
        } else {
          cov_p96fimrz6.b[1][1]++;
        }

        cov_p96fimrz6.s[12]++;

        if (config.delay !== undefined) {
          cov_p96fimrz6.b[2][0]++;
          cov_p96fimrz6.s[13]++;
          return config.delay;
        } else {
          cov_p96fimrz6.b[2][1]++;
        }

        cov_p96fimrz6.s[14]++;
        return defaultDelay;
      }
    }, {
      key: "handleChange",
      value: function handleChange(value) {
        var _this2 = this;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        cov_p96fimrz6.f[4]++;
        var delay = (cov_p96fimrz6.s[15]++, this.getDelay());
        cov_p96fimrz6.s[16]++;

        if (delay === 0) {
          var _this$props;

          cov_p96fimrz6.b[3][0]++;
          cov_p96fimrz6.s[17]++;

          (_this$props = this.props).onChange.apply(_this$props, [value].concat(args));

          cov_p96fimrz6.s[18]++;
          return;
        } else {
          cov_p96fimrz6.b[3][1]++;
        }

        cov_p96fimrz6.s[19]++;
        this.setState({
          value: value
        });
        cov_p96fimrz6.s[20]++;
        this.changeLocked = true;
        cov_p96fimrz6.s[21]++;
        this.forceUpdate();
        cov_p96fimrz6.s[22]++;

        if (this.changeTimer) {
          cov_p96fimrz6.b[4][0]++;
          cov_p96fimrz6.s[23]++;
          clearTimeout(this.changeTimer);
        } else {
          cov_p96fimrz6.b[4][1]++;
        }

        cov_p96fimrz6.s[24]++;
        this.changeTimer = setTimeout(function () {
          var _this2$props;

          cov_p96fimrz6.f[5]++;
          cov_p96fimrz6.s[25]++;
          _this2.changeLocked = false;
          cov_p96fimrz6.s[26]++;

          (_this2$props = _this2.props).onChange.apply(_this2$props, [value].concat(args));
        }, delay);
      }
    }, {
      key: "cancelChange",
      value: function cancelChange() {
        cov_p96fimrz6.f[6]++;
        cov_p96fimrz6.s[27]++;

        if (this.changeTimer) {
          cov_p96fimrz6.b[5][0]++;
          cov_p96fimrz6.s[28]++;
          clearTimeout(this.changeTimer);
        } else {
          cov_p96fimrz6.b[5][1]++;
        }
      }
    }, {
      key: "forceChange",
      value: function forceChange(value) {
        var _this$props2;

        cov_p96fimrz6.f[7]++;
        cov_p96fimrz6.s[29]++;
        this.cancelChange();
        cov_p96fimrz6.s[30]++;
        this.setState({
          value: value
        });
        cov_p96fimrz6.s[31]++;

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        (_this$props2 = this.props).onChange.apply(_this$props2, [value].concat(args));

        cov_p96fimrz6.s[32]++;
        this.changeLocked = false;
      }
    }, {
      key: "render",
      value: function render() {
        cov_p96fimrz6.f[8]++;

        var _ref2 = (cov_p96fimrz6.s[33]++, this.props),
            value = _ref2.value,
            onChange = _ref2.onChange,
            props = _objectWithoutProperties(_ref2, ["value", "onChange"]);

        cov_p96fimrz6.s[34]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, {
            value: this.getValue(),
            onChange: this.handleChange,
            forceChange: this.forceChange,
            cancelChange: this.cancelChange,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 73,
              columnNumber: 11
            }
          }))
        );
      }
    }]);

    return _temp;
  }(PureComponent), _temp;
});